import { createContext } from "react";
import type { GamePageContext } from "../game-types";

export const GameContext = createContext<GamePageContext | null>(null);
